'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { useSignUpHostStore } from '@/features/sign-up'

import { SignUpHostInfo } from './info'
import { SignUpHostIntro } from './intro'
import { SignUpHostPay } from './pay'
import { SignUpHostTerms } from './terms'
import { useValidateHostStep } from '../lib/use-validate-host-step'

export const SignUpHostPage = () => {
  useValidateHostStep()

  const actions = useSignUpHostStore(state => state.actions)

  const searchParams = useSearchParams()

  const step = searchParams?.get('step') || 'intro'

  useEffect(() => {
    return () => {
      actions.reset()
    }
  }, [actions])

  return (
    <>
      {(() => {
        if (step === 'intro') {
          return <SignUpHostIntro />
        }

        if (step === 'terms') return <SignUpHostTerms />

        if (step === 'info') return <SignUpHostInfo />

        if (step === 'pay') return <SignUpHostPay />

        return <SignUpHostIntro />
      })()}
    </>
  )
}
